export const APPLICATION_NAME = "XXX";
export const APPLICATION_NAME_NORMAL = "XXX";
export const APP_VERSION = "2.0.0";

export const LOCAL_STORAGE_ACCESS_TOKEN = `${APPLICATION_NAME}_ACCESS_TOKEN`;
export const LOCAL_STORAGE_REFRESH_TOKEN = `${APPLICATION_NAME}_REFRESH_TOKEN`;

export const LOCAL_STORAGE_PHONE_COUNTRY = `${APPLICATION_NAME}_PHONE_COUNTRY`;
export const LOCAL_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const SESSION_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;

export const googlePlacesKey = "AIzaSyCR388mWBleCqk4xOU2ZBjoBM_Aiu6VNt4";

export const SPLASH_SCREEN_DURATION_IN_MILLISECONDS = 400;

export const keyboardTypeEnum = {
  default: "default",
  email: "email-address",
  numeric: "number-pad",
  decimal: "decimal-pad",
  phone: "phone-pad",
};

export const FRONT_URL = "https://www.playbox.vip/";

export const LOGOUT = "logout";

export const AUTH_TYPE = {
  BASIC: "BASIC",
  TELEGRAM: "TELEGRAM",
  GOOGLE: "GOOGLE",
  DISCORD: "DISCORD",
};

export const MAX_USAGE_AFFILIATE = 400;

export const COLLECTION_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  NUDIFY_IN_PROGRESS: "NUDIFY_IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
};

export const DISCORD_CLIENT_ID = "1425338468229451858";

export const REGENERATE_DISCOUNT_PERCENTAGE = 0.15; // 15%
export const NUDIFY_PRICE = 15;

export const MEDIA_TYPE = {
  VIDEO: "VIDEO",
  IMAGE: "IMAGE",
};

export const VIDEO_RESOLUTION = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
};

export const ALL_VIDEO_RESOLUTIONS = [
  VIDEO_RESOLUTION.LOW,
  VIDEO_RESOLUTION.MEDIUM,
  VIDEO_RESOLUTION.HIGH,
];

export const DEFAULT_VIDEO_FPS = 45;
export const DEFAULT_VIDEO_DURATION = 5;

export const DEFAULT_VIDEO_RESOLUTION = VIDEO_RESOLUTION.MEDIUM;

export const VIDEO_RESOLUTION_PRICE = {
  LOW: 0,
  MEDIUM: 0,
  HIGH: 20,
};

export const VIDEO_RESOLUTION_TO_TIME = {
  LOW: "2-3",
  MEDIUM: "3-5",
  HIGH: "10-15",
};

export const VIDEO_DURATION_PRICE = {
  5: 0,
  7: 20,
  10: 40,
  12: 50,
};

export const VIDEO_FPS_PRICE = {
  30: 0,
  45: 0,
  60: 10,
};

export const PRO_VIDEO_DURATION = [10, 12];

export const MAX_VIDEO_SIZE = 20 * 1024 * 1024; // 20 MB

export const MAX_IMAGE_SIZE = 20 * 1024 * 1024; // 7 MB;

export const NUDIFY_MODEL_NAME = "GETTING_NAKED";

export const TRAIN_MODEL_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  SUBMITTED_FOR_TRAINING: "SUBMITTED_FOR_TRAINING",
  TRAINING: "TRAINING",
  TRAINING_COMPLETED: "TRAINING_COMPLETED",
  GENERATING_COLLECTIONS: "GENERATING_COLLECTIONS",
  COLLECTIONS_CREATED: "COLLECTIONS_CREATED",
  COMPLETED: "COMPLETED",
  SUBMITTED_FOR_REVIEW: "SUBMITTED_FOR_REVIEW",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  FAILED: "FAILED",
};

export const TRAIN_MODEL_STATUS_TEXT = {
  [TRAIN_MODEL_STATUS.IN_PROGRESS]: "Draft",
  [TRAIN_MODEL_STATUS.SUBMITTED_FOR_TRAINING]: "Submitted for training...",
  [TRAIN_MODEL_STATUS.TRAINING]: "Training...",
  [TRAIN_MODEL_STATUS.TRAINING_COMPLETED]: "Generating collections...",
  [TRAIN_MODEL_STATUS.GENERATING_COLLECTIONS]: "Generating collections...",
  [TRAIN_MODEL_STATUS.COLLECTIONS_CREATED]: "Train completed",
  [TRAIN_MODEL_STATUS.COMPLETED]: "Submit model for review",
  [TRAIN_MODEL_STATUS.SUBMITTED_FOR_REVIEW]: "Submitted for review...",
  [TRAIN_MODEL_STATUS.ACCEPTED]: "Accepted model",
  [TRAIN_MODEL_STATUS.DECLINED]: "Declined. Not eligible.",
};
